// removed by extract-text-webpack-plugin
module.exports = {"block":"Icon_block_3pJhm","svg":"Icon_svg_3elH8"};